module.exports = __webpack_public_path__ + "img/karl-kratz.f087f6c9.jpg";